import { createSelector } from 'reselect';
const currencySelector = state => state.multiCurrency;

// TODO: combineReducers is not correctly inferring reducer types. Need to solve
// this generally rather than cast everywhere
export const currencyInfoSelector = createSelector(currencySelector, currency => currency.get('currencyInfo'));
export const getCompanyCurrency = createSelector([currencyInfoSelector], currencyInfo => {
  if (currencyInfo && currencyInfo.get('homeCurrency')) {
    return currencyInfo.get('homeCurrency').get('currencyCode');
  }
  return '';
});
export const getCompanyCurrencyStatus = createSelector(currencySelector, currency => currency.get('currencyInfoStatus'));
export const getAvailableCurrencies = createSelector(currencyInfoSelector, currencyInfo => {
  const availableCurrencies = currencyInfo ? currencyInfo.get('currencyExchangeRates').toArray().filter(currencyExchangeRate => currencyExchangeRate.get('visible')) : [];
  return availableCurrencies.map(currency => currency.get('fromCurrencyCode'));
});
export const getCurrencyCountGreaterThanOne = createSelector(currencyInfoSelector, currencyInfo => {
  return (currencyInfo === null || currencyInfo === void 0 ? void 0 : currencyInfo.get('currencyExchangeRates')) && currencyInfo.get('currencyExchangeRates').filter(currencyExchangeRate => currencyExchangeRate.get('visible')).size > 1;
});